
/**
 * 获取用户信息
 * @param {Object} t 	Vue实例
 */
const getUserInfo = function(t) {
	return new Promise(((resolve, reject) => {
		t.$http.post('/app/getUserInfo').then(res=>{
			if( res.data.data ){
                localStorage.setItem('auth_mobile',res.data.data.mobile)
                localStorage.setItem('auth_uuid',res.data.data.uuid)
                if( res.data.data.share_code ){
                	localStorage.setItem('my_share_code',res.data.data.share_code)
                }
				resolve(res.data.data)
                t.$Im.checkOpenSocket(res.data.data.user_id)
				return
			}
		}).catch(err=>{
			reject(err)
		})
	}))
}

/**
 * 获取订单详情
 * @param {Object} t		VUE实例
 * @param {Number} order_id	订单号ID
 * @param {Number} type		1商城订单详情 3认养订单详情 4土地订单详情
 */
const getOrderDetail=function(t,order_id,type){
	return new Promise(((resolve, reject) => {
		t.$http.post('/app/getOrderDetail',{ order_id,type } ).then(res=>{
			if( res.data.data ){
				resolve(res.data.data)
				return
			}
		}).catch(err=>{
			reject(error)
		})
	}))
}

// 入驻年限
const ResidenceYears = function(nowTime) {
    let getYeardata = nowTime.split(" ")[0];
    //  年月日  时分秒
    let beforeYear = getYeardata.split("-")[0];
    let beforeMonth = getYeardata.split("-")[1];

    // 当前时间
    let myDate = new Date();
    myDate.getFullYear();

    let a = myDate.getFullYear() - beforeYear

    if (a === 0) {
        return 0
    }
    return a
}

/**
 * 获取农场配置信息
 * @param {Object} t
 * @param {Array} data		要获取的配置的名称
 */
const getFarmSet = function(t, data) {
    return new Promise(((resolve, reject) => {
        t.$http.get('/app/getFarmSet', {
            params: {
                keys: data
            }
        }).then(res => {
            if (res.data.data) {
                resolve(res.data.data)
                return
            }
            resolve('')
            return;
        }).catch(err => {
            reject(error)
        })
    }))
}




const priceFixdTo = function(num) {
    return num ? num.toFixed(2) : '0.00'
}

export default {
    getUserInfo,
    getOrderDetail,
    ResidenceYears,
    getFarmSet,
    priceFixdTo
}



// WEBPACK FOOTER //
// ./src/handle.js